import Paragraph from '@tiptap/extension-paragraph';

export default Paragraph.extend({
  addAttributes() {
    return {
      customAttribute: {
        default: null,
        parseHTML: (element) => ({
          style: element.getAttribute('data-style'),
          id: element.getAttribute('data-id') || '123',
          comment: element.getAttribute('data-comment'),
        }),
        renderHTML: (attributes) => {
          return {
            style: attributes.customAttribute?.style || '',
            id: attributes.customAttribute?.id || '',
          };
        },
        renderText: (attributes) => attributes && attributes.customAttribute,
      },
      // Enhanced support for inline styles
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute('style'),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return {
            style: attributes.style,
          };
        },
      },
    };
  },

  addKeyboardShortcuts() {
    return {
      ' ': () => {
        // Auto-format lists when typing "- " or "1. " followed by space
        const { state } = this.editor;
        const { selection } = state;
        const { $from } = selection;

        // Get the text before cursor in current paragraph
        const textBefore = $from.parent.textBetween(0, $from.parentOffset);

        // Check for bullet list patterns: "- ", "* ", "+ "
        if (textBefore.match(/^[-*+]\s*$/)) {
          // Remove the typed characters and convert to bullet list
          const tr = state.tr;
          tr.delete($from.start(), $from.pos);
          this.editor.view.dispatch(tr);
          return this.editor.commands.toggleBulletList();
        }

        // Check for numbered list pattern: "1. ", "2. ", etc.
        if (textBefore.match(/^\d+\.\s*$/)) {
          // Remove the typed characters and convert to numbered list
          const tr = state.tr;
          tr.delete($from.start(), $from.pos);
          this.editor.view.dispatch(tr);
          return this.editor.commands.toggleOrderedList();
        }

        return false;
      },
    };
  },
});
